import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import React from "react";
import { useData } from "../lib/context/DataContext";

import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Countdown from "../components/Countdown";
import Box from "@mui/material/Box";
import CardVente from "../components/Cards/CardVente";
import GridListProductCard from "../components/Cards/ProductCard/GridListProductCard";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import dayjs from "dayjs";
import "dayjs/locale/fr"; // Pour la langue française
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
dayjs.locale("fr");

export default function Dashboard() {
	//eslint-disable-next-line
	const { venteEnCours, prochaineVente } = useData();
	const [openAccordeon, setOpenAccordeon] = React.useState(null);

	const SkeletonVente = () => (
		<Skeleton
			variant="rounded"
			height={150}
		/>
	);

	const TitreSection = ({ children }) => (
		<Box>
			<Typography
				variant="h4"
				display={"flex"}
				justifyContent="space-between"
			>
				{children}
			</Typography>
			<Divider />
		</Box>
	);

	const VenteEnCoursContent = () => {
		if (venteEnCours === "novente") {
			return (
				<CardVente cover="./img/tableau_boucherie_2.JPG">
					Aucune vente d'ouverte...
				</CardVente>
			);
		} else if (venteEnCours && venteEnCours !== undefined)
			return (
				<GridListProductCard
					isOpen={venteEnCours.open}
					products={JSON.parse(venteEnCours.produitsEnVente)}
				/>
			);
		return <SkeletonVente />;
	};

	const ProchaineVente = () => {
		if (prochaineVente) {
			if (prochaineVente.length > 0) {
				return prochaineVente.map((nextVente) => (
					<Accordion
						key={nextVente.rowKey}
						variant="outlined"
						expanded={openAccordeon === nextVente.rowKey}
						onChange={() =>
							setOpenAccordeon((prev) =>
								prev === nextVente.rowKey
									? null
									: nextVente.rowKey
							)
						}
					>
						<AccordionSummary expandIcon={<ExpandMoreIcon />}>
							<Stack>
								<Typography variant="h6">
									Vente{" "}
									{nextVente.rowKey
										.replace("Vente-", "")
										.replace("-2025", "")
										.replace("-", " ")}
								</Typography>
								<Typography sx={{ color: "text.secondary" }}>
									La vente ouvrira{" "}
									{dayjs(
										nextVente.debutVente,
										"DD-MM"
									).format("dddd D MMMM")}{" "}
									à 9h
								</Typography>
							</Stack>
						</AccordionSummary>
						<AccordionDetails>
							<GridListProductCard
								type="showroom"
								products={JSON.parse(nextVente.produitsEnVente)}
							/>
						</AccordionDetails>
					</Accordion>
				));
			} else {
				return (
					<CardVente cover="./img/tableau_boucherie_1.JPG">
						Aucune vente de programmé...
					</CardVente>
				);
			}
		} else return <SkeletonVente />;
	};

	return (
		<Stack spacing={2}>
			<TitreSection>
				Vente en cours
				<Typography
					variant="h6"
					component={"p"}
					fontWeight="bold"
					color="secondary.main"
				>
					{venteEnCours && venteEnCours !== "novente" && (
						<>
							<Countdown
								date1={venteEnCours && venteEnCours.debutVente}
								date2={venteEnCours && venteEnCours.finVente}
							/>
						</>
					)}
				</Typography>
			</TitreSection>
			<VenteEnCoursContent />
			<TitreSection>Prochaine vente</TitreSection>
			<ProchaineVente />
		</Stack>
	);
}
